import React               from 'react';
import { Route, Routes } from 'react-router-dom';
import { Dashboard }       from './Dashboard';

export const DashboardRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={<Dashboard />}
    />
  </Routes>
);
